/* ============================================================================
   DAILE custom — PDP JS (Путь A). Изолированный, НЕ трогает theme.js.
   Подключается только к секции main-product-daile.liquid (defer).
   Сейчас: карусель отзывов (плавный slide, snap off на время анимации, B/C/D) +
   аккордеоны What's included (C) + NFC-модалка с ленивым видео (D).
   Хардкод-контент — в разметке блоков. Модалка портируется в <body>.
   ============================================================================ */
(function () {
  'use strict';

  /* DAILE custom (i18n): корень магазина с учётом языка — на арабской витрине это «/ar/».
     Без него ссылки уводили покупателя обратно на английскую версию. */
  var SHOP_ROOT_LOC = (function () {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  })();


  /* Раунд 6 (2026-09-30): кнопки покупки — «жидкое стекло» плашки шапки.
     Главная кнопка (Add to cart; на custom — Personalise this set) и кнопки липких панелей
     (капсула на телефоне, полоса на десктопе) получают атрибуты data-dv-glass с оптикой плашки
     шапки (sections/dv-header.liquid, [data-dv-header-pill]; значения читаются с неё, нет шапки —
     те же числа ниже). Стекло монтирует assets/dv-glass.js: скрипт выполняется до DOMContentLoaded
     (defer), поэтому кнопки монтируются вместе с секцией; кнопку, которую Prestige перерисовал
     (product-rerender заменяет <buy-buttons>), помечаем заново и монтируем вручную (DV.init).
     Подпись ATC уходит в отдельный span [data-mvp-atc-label]: dv-glass.js кладёт в кнопку слой
     стекла, а daile-mvp.js меняет подпись через этот span и слой не стирает.
     Стили — assets/dv-pdp-legacy-colors.css, раздел 14. */
  /* нет шапки — оптика плашки шапки на 2026-09-30 */
  var GLASS_FALLBACK = { 'data-dv-glass': '8', 'data-dv-glass-rim': '.5', 'data-dv-glass-bend': '1', 'data-dv-glass-dispersion': '.1', 'data-dv-glass-saturate': '1.5', 'data-dv-glass-clear': '.45' };
  var GLASS_CTA = '.daile-pdp .product-info .buy-buttons > button[type="submit"], .daile-pdp .product-info .daile-start-design-btn, .daile-pdp .daile-sticky__btn, .daile-pdp .daile-sticky-top__btn';
  function headerGlass() {
    var pill = document.querySelector('[data-dv-header-pill]');
    var out = {};
    if (pill) {
      Array.prototype.forEach.call(pill.attributes, function (a) {
        if (a.name.indexOf('data-dv-glass') === 0) out[a.name] = a.value;
      });
    }
    return out['data-dv-glass'] ? out : GLASS_FALLBACK;
  }
  function markCtaGlass() {
    var optics = null;
    var marked = [];
    Array.prototype.forEach.call(document.querySelectorAll(GLASS_CTA), function (el) {
      if (!el.hasAttribute('data-dv-glass')) {
        optics = optics || headerGlass();
        Object.keys(optics).forEach(function (name) { el.setAttribute(name, optics[name]); });
        el.classList.add('dpdp-glass-cta');
      }
      if (el.matches('.buy-buttons > button') && !el.querySelector('[data-mvp-atc-label]')) {
        var label = document.createElement('span');
        label.className = 'dpdp-cta__label';
        label.setAttribute('data-mvp-atc-label', '');
        Array.prototype.slice.call(el.childNodes).forEach(function (node) {
          if (!(node.nodeType === 1 && node.classList.contains('dv-glass-material'))) label.appendChild(node);
        });
        el.appendChild(label);
      }
      marked.push(el);
    });
    return marked;
  }
  markCtaGlass();
  /* монтируем вручную только после старта DV (dv.js, DOMContentLoaded): до него секции
     смонтирует сам DV, а ранний DV.init(кнопка) дал бы второй слой оптики */
  var dvStarted = false;
  function mountCtaGlass() {
    if (!dvStarted || !window.DV || typeof window.DV.init !== 'function') return;
    markCtaGlass().forEach(function (el) {
      if (!el.classList.contains('dv-glass-mounted')) {
        try { window.DV.init(el); } catch (e) { /* без стекла кнопка остаётся рабочей */ }
      }
    });
  }
  function initCtaGlass() {
    if (document.querySelector('.dv-glass-mounted')) { dvStarted = true; mountCtaGlass(); }
    else {
      document.addEventListener('dv:ready', function () { dvStarted = true; mountCtaGlass(); }, { once: true });
    }
    /* Prestige перерисовывает <buy-buttons> при смене варианта — новая кнопка без стекла */
    var info = document.querySelector('.daile-pdp .product-info');
    if (info && 'MutationObserver' in window) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; mountCtaGlass(); });
      }).observe(info, { childList: true, subtree: true });
    }
  }

  // плавная прокрутка с easing (ease-in-out), ~0.6s — мягче нативного smooth-скролла
  function animateScroll(el, to, duration, smooth, done) {
    var start = el.scrollLeft;
    var change = to - start;
    if (!smooth || Math.abs(change) < 1) { el.scrollLeft = to; if (done) done(); return; }
    var startTime = null;
    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; } // ease-in-out quad
    function step(ts) {
      if (startTime === null) startTime = ts;
      var t = Math.min((ts - startTime) / duration, 1);
      el.scrollLeft = start + change * ease(t);
      if (t < 1) { window.requestAnimationFrame(step); } else if (done) { done(); }
    }
    window.requestAnimationFrame(step);
  }

  function initReviews(root) {
    var track = root.querySelector('[data-daile-reviews-track]');
    var dotsWrap = root.querySelector('[data-daile-reviews-dots]');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return; // одна карточка — карусель не нужна

    var current = 0;
    var animToken = 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // --- точки-индикаторы (кликабельные) ---
    var dots = [];
    if (dotsWrap) {
      cards.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'daile-dot' + (i === 0 ? ' is-on' : '');
        d.setAttribute('aria-label', 'Перейти к отзыву ' + (i + 1));
        d.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    function setActive(i) {
      current = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }

    function goTo(i) {
      // offsetLeft учитывает gap между карточками (надёжнее, чем i*clientWidth).
      // ВАЖНО: на время кадровой анимации выключаем scroll-snap — иначе mandatory-snap
      // «телепортирует» к границе карточки и slide не виден (это и сломало анимацию в C).
      var my = ++animToken;
      track.style.scrollSnapType = 'none';
      animateScroll(track, cards[i].offsetLeft, 600, !reduceMotion, function () {
        if (my === animToken) track.style.scrollSnapType = ''; // вернуть snap после последней анимации
      });
      setActive(i);
    }

    // --- синхронизация точек при ручном свайпе/скролле ---
    var scrollT;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollT);
      scrollT = window.setTimeout(function () {
        var nearest = 0, min = Infinity;
        cards.forEach(function (c, k) {
          var dist = Math.abs(c.offsetLeft - track.scrollLeft);
          if (dist < min) { min = dist; nearest = k; }
        });
        setActive(nearest);
      }, 90);
    }, { passive: true });

    // --- автопрокрутка: первый переход через 2с, далее каждые 6с, зациклено ---
    var timer = null;
    var paused = false;

    function next() {
      goTo((current + 1) % cards.length);
    }
    function schedule(delay) {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (!paused) next();
        schedule(6000);
      }, delay);
    }

    // пауза при наведении/касании — не воюем с пользователем
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    root.addEventListener('touchend', function () { paused = false; }, { passive: true });

    if (!reduceMotion) schedule(2000);
  }

  // --- Аккордеоны (What's included и будущие) ---
  function initAccordions() {
    var accs = document.querySelectorAll('[data-daile-acc]');
    Array.prototype.forEach.call(accs, function (acc) {
      var btn = acc.querySelector('[data-daile-acc-toggle]');
      var body = acc.querySelector('[data-daile-acc-body]');
      if (!btn || !body) return;
      btn.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '';
      });
    });
  }

  // --- NFC модалка (ленивое видео, портал в <body>, Esc/фон/крестик) ---
  function initNfc() {
    var modal = document.querySelector('[data-daile-nfc-modal]');
    if (!modal) return;

    // Портируем модалку в <body>: чтобы position:fixed / z-index работали поверх
    // всего и не зависели от transform/stacking-context предков секции.
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var openers = document.querySelectorAll('[data-daile-nfc-open]');
    var closers = modal.querySelectorAll('[data-daile-modal-close]');
    var video = modal.querySelector('video');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      if (video) {
        // ленивая загрузка: src ставится ТОЛЬКО при открытии (до этого трафик = 0)
        // 2026-09-29: и кадр-заставка тоже (data-poster) — чтобы вертикальный ролик
        // не показывал пустую рамку, пока грузится.
        if (video.dataset.poster && !video.getAttribute('poster')) {
          video.setAttribute('poster', video.dataset.poster);
        }
        if (video.dataset.src && !video.getAttribute('src')) {
          video.setAttribute('src', video.dataset.src);
        }
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    function close() {
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (video) video.pause();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    Array.prototype.forEach.call(openers, function (o) {
      o.addEventListener('click', open);
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); open(); }
      });
    });
    Array.prototype.forEach.call(closers, function (c) {
      c.addEventListener('click', close);
    });
    // клик по затемнённому фону (сам оверлей, не диалог)
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    // Esc
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && modal.classList.contains('is-open')) close();
    });
  }

  // --- Табы (Details / Shipping) ---
  function initTabs() {
    var groups = document.querySelectorAll('[data-daile-tabs]');
    Array.prototype.forEach.call(groups, function (group) {
      var btns = group.querySelectorAll('[data-daile-tab]');
      var panes = group.querySelectorAll('[data-daile-pane]');
      Array.prototype.forEach.call(btns, function (btn, i) {
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(btns, function (b, k) {
            b.classList.toggle('is-on', k === i);
            b.setAttribute('aria-selected', k === i ? 'true' : 'false');
          });
          Array.prototype.forEach.call(panes, function (p, k) {
            p.classList.toggle('is-on', k === i);
          });
        });
      });
    });
  }

  // --- Липкая ATC-панель (мобайл): видна по умолчанию, прячется когда
  //     основная CTA в зоне видимости. Клик форвардится на основную кнопку. ---
  // 2026-09-29: обе панели — плавающие «стеклянные» плашки (daile-pdp.css).
  //   • капсула (телефон) дополнительно уезжает, пока в кадре футер (IntersectionObserver),
  //     чтобы не закрывать последние ссылки и копирайт;
  //   • полоса (десктоп) стоит ПОД плашкой шапки: меряем плашку и отдаём CSS
  //     --dpdp-bar-top / -left / -width (тот же зазор и та же ширина, шапку не перекрывает).
  function initStickyCta() {
    // Капсула [data-daile-sticky] (телефон) и десктопная полоса [data-daile-sticky-top] имеют РАЗНЫЕ механизмы
    // показа, поэтому обрабатываются раздельно. Видна та, что соответствует брейкпоинту (решает CSS-медиа).
    var capsule = document.querySelector('[data-daile-sticky]');      // мобильная капсула
    var topbar  = document.querySelector('[data-daile-sticky-top]');  // десктопная полоса
    if (!capsule && !topbar) return;
    // TASK36: основной CTA = ATC (art, .buy-buttons button) ИЛИ Start Design (custom, .daile-start-design-btn)
    var mainCta = document.querySelector('.daile-pdp .product-info .buy-buttons button, .daile-pdp .product-info .daile-start-design-btn');

    if (mainCta) {
      // ATC-кнопки капсулы И полосы (art) проксируют клик на основной CTA → нативный add-to-cart.
      // На custom это ссылки <a> БЕЗ data-daile-sticky-add → сюда не попадают (ведут в движок нативно).
      Array.prototype.forEach.call(document.querySelectorAll('[data-daile-sticky-add]'), function (btn) {
        btn.addEventListener('click', function () { mainCta.click(); });
      });
    }

    // Футер в кадре → капсула уезжает (класс .is-at-footer, анимацию и reduced-motion решает CSS).
    if (capsule && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.dv-footer') ||
                   document.querySelector('.shopify-section--footer') ||
                   document.querySelector('footer');
      if (footer) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { capsule.classList.toggle('is-at-footer', e.isIntersecting); });
        }, { threshold: 0 }).observe(footer);
      }
    }

    // Нет основного CTA — показываем обе по умолчанию (fallback).
    if (!mainCta) {
      if (capsule) capsule.classList.add('is-visible');
      if (topbar)  topbar.classList.add('is-visible');
      return;
    }

    // --- Капсула (мобайл): видна по умолчанию, IO прячет её, когда CTA попадает во вьюпорт ---
    if (capsule) {
      capsule.classList.add('is-visible');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { capsule.classList.toggle('is-visible', !e.isIntersecting); });
        }, { threshold: 0 }).observe(mainCta);
      }
    }

    // --- Десктопная полоса: скролл + ГИСТЕРЕЗИС + компенсация скролла ---
    // Полоса видна, когда основной CTA вне вьюпорта (ушёл под шапку/за верх ИЛИ ниже экрана — в т.ч. при первой загрузке).
    // CSS (:has) резервирует под полосу отступ (--daile-topbar-h = высота плашки + зазор); в момент появления/скрытия
    // компенсируем скролл, чтобы контент не прыгнул. Гистерезис (мёртвая зона ШИРЕ резерва) не даёт компенсации
    // зациклиться в «дрожь» — она была заметна в Safari (нет scroll-anchoring) при медленном скролле.
    if (topbar) {
      var deskMq = window.matchMedia('(min-width: 1000px)');
      var barShown = false;
      var ticking = false;
      var GAP = 12; // зазор между плашкой шапки и полосой = отступ плашки шапки от края экрана
      var pill = document.querySelector('[data-dv-header-pill]') || document.querySelector('.dv-header__pill');
      // Sale marquee (первая секция под шапкой): пока она в кадре, полоса встаёт под неё.
      var marquee = document.querySelector('.daile-marquee');
      var reserve = function () {
        var v = parseFloat(window.getComputedStyle(topbar).getPropertyValue('--daile-topbar-h'));
        return v > 0 ? v : (topbar.offsetHeight || 60) + GAP;
      };
      var lastPlace = '';
      // Ставит полосу под плашку шапки. Возвращает верхнюю границу полосы (px от верха окна).
      var placeBar = function () {
        var top = null;
        if (pill) {
          var r = pill.getBoundingClientRect();
          if (r.width > 0 && r.height > 0) {
            top = Math.max(0, r.bottom) + GAP;
            var key = Math.round(top) + '|' + Math.round(r.left) + '|' + Math.round(r.width);
            if (key !== lastPlace) {
              lastPlace = key;
              topbar.style.setProperty('--dpdp-bar-left', r.left + 'px');
              topbar.style.setProperty('--dpdp-bar-width', r.width + 'px');
              topbar.setAttribute('data-dpdp-placed', '');
            }
          }
        }
        if (marquee) {
          var mBottom = marquee.getBoundingClientRect().bottom;
          if (mBottom > 0 && (top === null || mBottom + GAP > top)) top = mBottom + GAP;
        }
        if (top === null) {
          topbar.style.removeProperty('--dpdp-bar-top');
          return parseFloat(window.getComputedStyle(topbar).top) || 94;
        }
        topbar.style.setProperty('--dpdp-bar-top', top + 'px');
        return top;
      };
      var updateBar = function () {
        ticking = false;
        // Раунд 7 (производительность): ниже 1000px полосы нет (display: none в daile-pdp.css) —
        // раньше она всё равно мерялась и получала стили/классы в каждом кадре прокрутки
        // (а .is-visible ещё и пересчитывал :has() всей карточки товара).
        if (!deskMq.matches) {
          if (barShown) { barShown = false; topbar.classList.remove('is-visible'); }
          return;
        }
        var barTop = placeBar();
        var rect = mainCta.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var res = reserve();
        var next = barShown;
        if (!barShown) {
          // показать: CTA ушёл под шапку / за верх вьюпорта ИЛИ опустился ниже него
          if (rect.bottom <= barTop || rect.top >= vh) next = true;
        } else if (rect.top < vh && rect.bottom > barTop + res + 12) {
          // скрыть: CTA вернулся во вьюпорт ниже полосы. Порог с запасом (шире резерва),
          // чтобы scrollBy-компенсация не вытолкнула CTA обратно за край → без дрожи.
          next = false;
        }
        if (next === barShown) return;
        barShown = next;
        topbar.classList.toggle('is-visible', next);
        if (deskMq.matches && window.pageYOffset > 0) {
          // мгновенно: на страницах dv у html стоит scroll-behavior: smooth, и
          // компенсация иначе ехала бы анимацией (контент заметно «плыл»)
          try { window.scrollBy({ top: next ? res : -res, left: 0, behavior: 'instant' }); }
          catch (e) { window.scrollBy(0, next ? res : -res); }
        }
      };
      var onScroll = function () {
        if (!ticking) { ticking = true; requestAnimationFrame(updateBar); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { lastPlace = ''; onScroll(); });
      updateBar();
    }
  }

  // Раунд 4 (2026-09-30): липкие панели над винной главой. Пока под капсулой (телефон) или под
  // полосой (десктоп) лежит винный фон — первый экран .daile-pdp--wine или винная секция dv
  // (художник), — панель получает .is-over-wine: капсула становится светлой, полоса — deep
  // (стили: assets/dv-pdp-legacy-colors.css, 6.10). Проверка — по середине панели, раз в кадр
  // при прокрутке и при смене размеров окна.
  function initStickyOnWine() {
    var panels = Array.prototype.slice.call(document.querySelectorAll('[data-daile-sticky], [data-daile-sticky-top]'));
    if (!panels.length || !document.querySelector('.daile-pdp--wine')) return;
    var surfaces = function () {
      return document.querySelectorAll('.daile-pdp--wine, #main .dv-section--wine');
    };
    var ticking = false;
    var update = function () {
      ticking = false;
      var list = surfaces();
      panels.forEach(function (panel) {
        var r = panel.getBoundingClientRect();
        if (!r.height) return; // панель скрыта на этом брейкпоинте (display: none)
        var mid = r.top + r.height / 2;
        var over = false;
        for (var i = 0; i < list.length; i++) {
          var s = list[i].getBoundingClientRect();
          if (s.height && mid >= s.top && mid <= s.bottom) { over = true; break; }
        }
        panel.classList.toggle('is-over-wine', over);
      });
    };
    var request = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    update();
  }

  // --- Карусели с точками (мобайл): A Moment + Loved By Thousands ---
  function buildScrollDots(track, dotsWrap) {
    if (!track || !dotsWrap) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return;
    var dots = cards.map(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'daile-dot' + (i === 0 ? ' is-on' : '');
      // DAILE i18n: подпись из daile-t (dv_cmp_slide, «Slide {n}») через data-t-slide
      d.setAttribute('aria-label', (dotsWrap.getAttribute('data-t-slide') || 'Slide {n}').replace('{n}', String(i + 1)));
      d.addEventListener('click', function () {
        track.scrollTo({ left: cards[i].offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(d);
      return d;
    });
    var t;
    track.addEventListener('scroll', function () {
      window.clearTimeout(t);
      t = window.setTimeout(function () {
        var nearest = 0, min = Infinity;
        cards.forEach(function (c, k) {
          var dist = Math.abs(c.offsetLeft - track.scrollLeft);
          if (dist < min) { min = dist; nearest = k; }
        });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === nearest); });
      }, 90);
    }, { passive: true });
  }
  function initDotsCarousels() {
    buildScrollDots(document.querySelector('.daile-occ__track'), document.querySelector('.daile-occ__dots'));
    // TASK31: btmrev-dots убраны — блок отзывов теперь непрерывная marquee-лента (CSS), не dots-карусель
  }

  // --- Автопрокрутки нижних каруселей (TASK5 п.7) — ТОЛЬКО мобайл, через IntersectionObserver.
  //     Пуск когда секция видна ≥50%; уход из viewport → пауза (currentIndex сохраняется).
  //     Ручной жест (touch/pointer/wheel) → пауза 5с. Программный smooth-скролл НЕ слушаем
  //     как «жест» (иначе автопрокрутка паузила бы сама себя). scroll → только синк индекса. ---
  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 999px)').matches;
  }
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // общий помощник: синк currentIndex по реальной позиции скролла (debounce)
  function nearestIndex(track, cards) {
    var nearest = 0, min = Infinity;
    cards.forEach(function (c, k) {
      var d = Math.abs(c.offsetLeft - track.scrollLeft);
      if (d < min) { min = d; nearest = k; }
    });
    return nearest;
  }

  // A Moment Worth Keeping — 2с на карточку, зацикленно
  function initOccAutoplay() {
    if (!isMobile() || prefersReducedMotion()) return;
    var section = document.querySelector('.daile-occ');
    if (!section) return;
    var track = section.querySelector('.daile-occ__track');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return;

    var currentIndex = 0, timer = null, lastInteractionAt = 0, st = null;

    function advance() {
      if (Date.now() - lastInteractionAt < 5000) return; // пауза после ручного свайпа
      currentIndex = (currentIndex + 1) % cards.length;
      track.scrollTo({ left: cards[currentIndex].offsetLeft, behavior: 'smooth' });
    }
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { lastInteractionAt = Date.now(); }, { passive: true });
    });
    track.addEventListener('scroll', function () {
      window.clearTimeout(st);
      st = window.setTimeout(function () { currentIndex = nearestIndex(track, cards); }, 120);
    }, { passive: true });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          if (!timer) timer = window.setInterval(advance, 2000);
        } else if (timer) {
          window.clearInterval(timer); timer = null;
        }
      });
    }, { threshold: 0.5 }).observe(section);
  }

  // Loved By Thousands — первая карточка 4с, остальные 6с, зацикленно
  function initBtmRevAutoplay() {
    if (!isMobile() || prefersReducedMotion()) return;
    var section = document.querySelector('.daile-btmrev');
    if (!section) return;
    var track = section.querySelector('.daile-btmrev__track');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return;

    var currentIndex = 0, timer = null, lastInteractionAt = 0, visible = false, st = null;

    function delayFor(i) { return i === 0 ? 4000 : 6000; }
    function schedule() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (Date.now() - lastInteractionAt >= 5000) {
          currentIndex = (currentIndex + 1) % cards.length;
          track.scrollTo({ left: cards[currentIndex].offsetLeft, behavior: 'smooth' });
        }
        if (visible) schedule();
      }, delayFor(currentIndex));
    }
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { lastInteractionAt = Date.now(); }, { passive: true });
    });
    track.addEventListener('scroll', function () {
      window.clearTimeout(st);
      st = window.setTimeout(function () { currentIndex = nearestIndex(track, cards); }, 120);
    }, { passive: true });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          if (!visible) { visible = true; schedule(); }
        } else {
          visible = false; window.clearTimeout(timer); timer = null;
        }
      });
    }, { threshold: 0.5 }).observe(section);
  }

  // UGC reel — бесконечная лента (CSS-анимация). JS лишь дёргает .is-playing по видимости.
  // CSS гейтит анимацию мобайлом + reduced-motion, поэтому matchMedia тут не нужен.
  function initUgcMarquee() {
    var section = document.querySelector('.daile-ugc');
    if (!section || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        section.classList.toggle('is-playing', e.isIntersecting);
      });
    }, { threshold: 0.5 }).observe(section);
  }

  // TASK31: блок отзывов «Loved By Thousands» — лента играет ТОЛЬКО когда секция видна (как UGC). Пауза по :hover — в CSS.
  function initBtmRevMarquee() {
    var section = document.querySelector('.daile-btmrev');
    if (!section || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        section.classList.toggle('is-playing', e.isIntersecting);
      });
    }, { threshold: 0.15 }).observe(section);
  }

  // --- Qty + ATC в одну строку (TASK3 п.3) ---
  // Нативные блоки quantity_selector и buy_buttons Prestige рендерит отдельными
  // .product-info__block-item (вертикальной стопкой). Оборачиваем оба в .daile-qrow,
  // чтобы CSS положил их в ряд. Идемпотентно (повторный вызов ничего не ломает).
  // NB: товар без вариантов → product-rerender не перерисовывает инфо-колонку,
  // поэтому обёртка не «слетает». Появятся варианты — пересмотреть.
  function initQtyRow() {
    var qty = document.querySelector('.daile-pdp .product-info__block-item[data-block-type="quantity-selector"]');
    var buy = document.querySelector('.daile-pdp .product-info__block-item[data-block-type="buy-buttons"]');
    if (!qty || !buy) return;
    if (qty.parentNode !== buy.parentNode) return; // должны быть сиблингами
    if (qty.closest('.daile-qrow')) return;        // уже обёрнуты
    var row = document.createElement('div');
    row.className = 'daile-qrow';
    qty.parentNode.insertBefore(row, qty);
    row.appendChild(qty);
    row.appendChild(buy);
  }

  // --- FAQ аккордеон (Popular Questions) ---
  function initFaq() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.daile-faq__item'));
    items.forEach(function (item) {
      var q = item.querySelector('.daile-faq__q');
      var a = item.querySelector('.daile-faq__a');
      if (!q || !a) return;
      q.setAttribute('aria-expanded', 'false');
      q.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        // TASK3 п.6: single-open — закрываем ВСЕ, потом открываем текущий (если был закрыт).
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var oa = other.querySelector('.daile-faq__a');
          if (oa) oa.style.maxHeight = '';
          var oq = other.querySelector('.daile-faq__q');
          if (oq) oq.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // Perfect for Memories — 3 декоративных видео. Autoplay ТОЛЬКО в зоне видимости:
  // HTML-атрибута autoplay нет, играем из JS через IntersectionObserver (threshold 0.3).
  // muted + playsinline → мобильные браузеры разрешают программный play(); pause без сброса.
  function initMemoriesVideo() {
    if (!('IntersectionObserver' in window) || prefersReducedMotion()) return;
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-autoplay-in-view]'));
    if (!vids.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var p = e.target.play();
          if (p && p.catch) p.catch(function () {}); // браузер заблокировал autoplay — молча
        } else {
          e.target.pause(); // пауза, позицию не сбрасываем
        }
      });
    }, { threshold: 0.3 });
    vids.forEach(function (v) { io.observe(v); });
  }

  // TASK price: нативный price-блок Prestige рендерит money_with_currency («€100,00 EUR»).
  // Приводим к виду корзины (TASK28): Intl.NumberFormat без копеек → «€100» / «SAR 100».
  // ЗНАЧЕНИЕ берём из самого нативного текста (точная presentment-цена, включая Markets price-lists) —
  // только ПЕРЕформатируем (символ/код по валюте покупателя + без .00), сумму не пересчитываем по rate.
  // Реактивно: повторяем после смены варианта (Prestige product:rerender / variant:change).
  function initDailePriceFormat() {
    var root = document.querySelector('.daile-pdp');
    if (!root || typeof Intl === 'undefined') return;
    var locale = (window.Shopify && Shopify.locale) || undefined;

    function reformat() {
      var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var nodes = root.querySelectorAll('.price-list sale-price, .price-list compare-at-price');
      Array.prototype.forEach.call(nodes, function (el) {
        var node = el.lastChild; // money — текстовый узел после <span class="sr-only">
        if (!node || node.nodeType !== 3 || !/\d/.test(node.nodeValue)) return;
        // целое presentment-значение: убрать символ/код → убрать копейки (,00 / .00) → убрать разделители тысяч
        var digits = node.nodeValue.replace(/[^\d.,]/g, '').replace(/[.,]\d{2}$/, '').replace(/[.,]/g, '');
        var amount = parseInt(digits, 10);
        if (isNaN(amount)) return;
        try {
          node.nodeValue = new Intl.NumberFormat(locale, {
            style: 'currency', currency: code, numberingSystem: 'latn', // цифры как у daile-money (0-9) и на /ar
            minimumFractionDigits: 0, maximumFractionDigits: 0
          }).format(amount);
        } catch (e) {}
      });
    }

    reformat();
    document.addEventListener('variant:change', function () { window.setTimeout(reformat, 0); });
    document.addEventListener('product:rerender', function () { window.setTimeout(reformat, 30); });
  }

  // --- TASK95: загрузка фото с PDP → кастомайзер ------------------------------
  // Файл кладём в ТУ ЖЕ IndexedDB, что использует кастомайзер (база 'daile-cz',
  // стор 'photos'), под служебным ключом 'photo_pdp-pending' — кастомайзер на
  // старте принимает его как обычную загрузку и удаляет запись. Форматы записи
  // те же, что понимает его edit-режим: File напрямую ЛИБО {buf, type} (fallback
  // для браузеров, не сериализующих File). IndexedDB недоступна (Safari private
  // и т.п.) → мягкая деградация: просто переходим, человек загрузит заново.
  function initPdpUpload() {
    var input = document.querySelector('[data-daile-pdp-upload]');
    if (!input) return;
    var zone = document.querySelector('[data-daile-pdp-upload-zone]');
    var errEl = document.querySelector('[data-daile-pdp-upload-error]');

    function idbSavePending(file) {
      return new Promise(function (resolve, reject) {
        var rq;
        try { rq = window.indexedDB.open('daile-cz', 1); } catch (e) { reject(e); return; }
        rq.onupgradeneeded = function () { rq.result.createObjectStore('photos'); };
        rq.onerror = function () { reject(rq.error); };
        rq.onsuccess = function () {
          var db = rq.result;
          function put(val, onFail) {
            try {
              var tx = db.transaction('photos', 'readwrite');
              tx.objectStore('photos').put(val, 'photo_pdp-pending');
              tx.oncomplete = function () { resolve(); };
              tx.onerror = function () { onFail(tx.error); };
            } catch (e) { onFail(e); }
          }
          put(file, function () {
            // File не сериализуется (старые Safari) → кладём {buf, type}
            var fr = new FileReader();
            fr.onload = function () { put({ buf: fr.result, type: file.type }, reject); };
            fr.onerror = function () { reject(fr.error); };
            fr.readAsArrayBuffer(file);
          });
        };
      });
    }

    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (!file) return;
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        if (errEl) { errEl.textContent = errEl.getAttribute('data-msg-type') || 'Please upload a JPG or PNG photo.'; errEl.removeAttribute('hidden'); }
        input.value = '';
        return;
      }
      // TASK98: лимит воркера (MAX_ORIGINAL_MB) — говорим сразу, а не на кассе
      if (file.size > 60 * 1024 * 1024) {
        if (errEl) { errEl.textContent = errEl.getAttribute('data-msg-size') || 'This photo is over 60 MB — please use a smaller file (JPG works best).'; errEl.removeAttribute('hidden'); }
        input.value = '';
        return;
      }
      if (errEl) errEl.setAttribute('hidden', '');
      if (zone) zone.classList.add('is-busy');
      // 2026-09-29: вместе с фото передаём и выбранный на странице набор
      // (блок тиров, daile-mvp.js → window.DAILE_MVP.czSet): кастомайзер
      // читает ?set= и сразу открывает шаг загрузки с этим набором.
      // Раунд 2: и галочку клея у Mini (&glue=1 — кастомайзер отметит клей на шаге Review).
      var st = window.DAILE_MVP;
      var set = (st && st.czSet && document.querySelector('[data-mvp-pdp-tiers]')) ? st.czSet : '';
      var setQ = set ? 'set=' + encodeURIComponent(set) + (st.czGlue ? '&glue=1' : '') : '';
      idbSavePending(file)
        .then(function () { window.location.href = SHOP_ROOT_LOC + 'pages/customizer?pdp=1' + (setQ ? '&' + setQ : ''); })
        ['catch'](function () { window.location.href = SHOP_ROOT_LOC + 'pages/customizer' + (setQ ? '?' + setQ : ''); });
    });

    // Возврат «назад» из кастомайзера: bfcache восстанавливает страницу с
    // заблокированной кнопкой (is-busy + выбранный файл) — снимаем блокировку
    window.addEventListener('pageshow', function () {
      if (zone) zone.classList.remove('is-busy');
      try { input.value = ''; } catch (e) { /* IE-грабли не актуальны */ }
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-daile-reviews]');
    Array.prototype.forEach.call(roots, initReviews);
    initAccordions();
    initNfc();
    initTabs();
    initStickyCta();
    initStickyOnWine(); // раунд 4: светлая капсула / deep-полоса над винной главой
    initCtaGlass();     // раунд 6: кнопки покупки — «жидкое стекло» шапки
    // TASK6: initQtyRow отключён — qty теперь отдельной строкой (не в ряд с ATC)
    initDotsCarousels();
    initFaq();
    initOccAutoplay();
    initBtmRevMarquee(); // TASK31: лента отзывов играет только когда секция видна (IntersectionObserver)
    initUgcMarquee();
    initMemoriesVideo();
    initDailePriceFormat();
    initPdpUpload(); // TASK95: загрузка фото с PDP → кастомайзер
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
